<script>
  import { formatMoney, ignore } from '../../Common/tools';
  import { onMount } from 'svelte';
  import ConfirmAddon from './ConfirmAddon.svelte';
  import { fly } from 'svelte/transition';
  import { External, M } from '../../external';
  import { disableAddon, formatNumber } from './addons';

  export let onChange = ignore, onCanceled = ignore, addon = null, subscription, showLimitsReachedMessage = false;
  let addons = [];
  let confirming = false;
  let initialValue = -1;

  let planLimit = subscription.planDetailsNoAddons['circles'];
  let planLimitMembers = subscription.planDetailsNoAddons['circleMembers'];
  let canUseWithoutAddon = planLimit > 0;
  let features = {
    names: [M.FREE, External.format(M.TIER, 'x', 1), External.format(M.TIER, 'x', 2), External.format(M.TIER, 'x', 3), External.format(M.TIER, 'x', 4)],
    circles: [canUseWithoutAddon ? planLimit : 0, 1, 5, 999, 999],
    members: [canUseWithoutAddon ? planLimitMembers : 0, 1000, 5000, 10000, 999],
    videos: [0, 0, 30, 50, 100],
    boards: [canUseWithoutAddon ? 1 : 0, 999, 999, 999, 999],
    walls: [canUseWithoutAddon ? 1 : 0, 999, 999, 999, 999]
  };

  let select = async (selected) => {
    if (selected.value === -1) {
      let result = await disableAddon(selected);
      if (result) {
        onChange(result);
      }
    } else {
      addon = selected;
      confirming = true;
    }
  };

  onMount(() => {
    addons = [
      { value: -1, monthlyPrice: 0, type: 'COMMUNITY' },
      ...External.Website.addons.filter(addon => addon.type === 'COMMUNITY').sort((a, b) => a.value - b.value)
    ];
    if (!addon) {
      addon = subscription.addons.find(addon => addon.type === 'COMMUNITY');
      if (!addon) {
        addon = addons[0];
      }
    }
    initialValue = addon.value;
  });
</script>
<div class="popup-widget-wrapper" style="overflow-x: hidden">

  <div class="col20 f-left t-left flex align-center flex-col">
    <h2 class="col20 f-left mt-15 t-center big-title-popup">{M.COMMUNITY}</h2>
    {#if showLimitsReachedMessage}
      <h4 class="col20 f-left mt-15 t-center big-title-popup">{M.RESOURCE_LIMIT_REACHED}</h4>
    {/if}
    <div class="col12 f-left t-center mt-10 light-gray-text f-14-regular">{M.EXTRA_COMMUNITY_DESC}</div>
  </div>

  {#if confirming}
    <div class="col20 f-left" in:fly={{x: '100%'}}>
      <ConfirmAddon {addon} currency={subscription.currency} value={addon.value} taxRate={subscription.activeVatPercent} widthClass="col12"
                    on:cancel={() => confirming = false}
                    on:confirm={(event) => onChange(event.detail)} />
    </div>
  {:else}
    <div class="price-tables-wrapper table-of-five col20 f-left mt-15" in:fly={{x: '-100%'}}>
      {#each addons as addon, index}
        <div class="price-table"
             class:most-popular={initialValue === addon.value}
             class:highlight-table={initialValue === addon.value}
             class:current-plan={initialValue === addon.value}
        >
          <div class="price-table-inner">
            {#if initialValue === addon.value}
              <div class="badge">{M.CURRENT_PLAN}</div>
            {/if}
            <h4 class="price-table-name">{features.names[index]}</h4>
            <h3 class="price-table-value monthly">
              {@html formatMoney(addon.monthlyPrice, subscription.currency, true, true)}<span class="price-table-period">/{M.MONTH}
              {#if subscription.activeVatPercent && addon.monthlyPrice > 0}
                <span class="col20 f-left mt-5 price-table-support-text">{M.TAX_PLUS}</span>
              {/if}
            </span>
            </h3>
            <div class="price-table-description">
              <ul class="icon-list-wrapper">
                <li class="icon-list-item" class:disabled={features.circles[index] === 0}>
                  {#if features.circles[index] === 0}
                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368">
                      <path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" />
                    </svg>
                    <span class="icon-list-name">
                      {M.CIRCLES}
                    </span>
                  {:else}
                    <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 -960 960 960" width="48">
                      <path d="M378-222 130-470l68-68 180 180 383-383 68 68-451 451Z"></path>
                    </svg>
                    <span class="icon-list-name">
                    {formatNumber(features.circles[index], M.ONE_CIRCLE, M.CIRCLE_NUMBER, M.UNLIMITED_CIRCLES)}
                  </span>
                  {/if}
                </li>
                {#if features.members[index] > 0}
                  <li class="icon-list-item">
                    <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 -960 960 960" width="48">
                      <path d="M378-222 130-470l68-68 180 180 383-383 68 68-451 451Z"></path>
                    </svg>
                    <span class="icon-list-name">
                    {formatNumber(features.members[index], '', M.UP_TO_MEMBERS, M.UNLIMITED_MEMBERS)}
                  </span>
                  </li>
                {/if}
                {#if features.videos[index] > 0}
                  <li class="icon-list-item">
                    <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 -960 960 960" width="48">
                      <path d="M378-222 130-470l68-68 180 180 383-383 68 68-451 451Z"></path>
                    </svg>
                    <span class="icon-list-name">
                      +{formatNumber(features.videos[index], '', M.X_VIDEOS, M.UNLIMITED_VIDEOS)}
                    </span>
                  </li>
                {/if}
                <li class="icon-list-item" class:disabled={features.boards[index] === 0}>
                  {#if features.boards[index] === 0}
                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368">
                      <path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" />
                    </svg>
                  {:else}
                    <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 -960 960 960" width="48">
                      <path d="M378-222 130-470l68-68 180 180 383-383 68 68-451 451Z"></path>
                    </svg>
                  {/if}
                  <span class="icon-list-name">
                    {formatNumber(features.boards[index] === 0 ? 999 : features.boards[index], M.ONE_BOARD, M.X_BOARDS, M.UNLIMITED_BOARDS)}
                  </span>
                </li>
                <li class="icon-list-item" class:disabled={features.walls[index] === 0}>
                  {#if features.walls[index] === 0}
                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368">
                      <path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" />
                    </svg>
                  {:else}
                    <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 -960 960 960" width="48">
                      <path d="M378-222 130-470l68-68 180 180 383-383 68 68-451 451Z"></path>
                    </svg>
                  {/if}
                  <span class="icon-list-name">
                    {formatNumber(features.walls[index] === 0 ? 999 : features.walls[index], M.ONE_SOCIAL_WALL, M.X_SOCIAL_WALLS, M.UNLIMITED_WALLS)}
                  </span>
                </li>
                <li class="icon-list-item" class:disabled={features.circles[index] === 0}>
                  {#if features.circles[index] === 0}
                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368">
                      <path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" />
                    </svg>
                  {:else}
                    <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 -960 960 960" width="48">
                      <path d="M378-222 130-470l68-68 180 180 383-383 68 68-451 451Z"></path>
                    </svg>
                  {/if}
                  <span class="icon-list-name">{M.ANALYTICS}</span>
                </li>
                <li class="icon-list-item" class:disabled={features.circles[index] === 0}>
                  {#if features.circles[index] === 0}
                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368">
                      <path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" />
                    </svg>
                  {:else}
                    <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 -960 960 960" width="48">
                      <path d="M378-222 130-470l68-68 180 180 383-383 68 68-451 451Z"></path>
                    </svg>
                  {/if}
                  <span class="icon-list-name">{M.UNLIMITED_PAGES}</span>
                </li>
                <li class="icon-list-item" class:disabled={addon.value === -1}>
                  {#if addon.value === -1}
                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368">
                      <path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" />
                    </svg>
                  {:else}
                    <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 -960 960 960" width="48">
                      <path d="M378-222 130-470l68-68 180 180 383-383 68 68-451 451Z"></path>
                    </svg>
                  {/if}
                  <span class="icon-list-name">{M.DRIP_CONTENT}</span>
                </li>
                <li class="icon-list-item" class:disabled={addon.value === -1}>
                  {#if addon.value === -1}
                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368">
                      <path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" />
                    </svg>
                  {:else}
                    <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 -960 960 960" width="48">
                      <path d="M378-222 130-470l68-68 180 180 383-383 68 68-451 451Z"></path>
                    </svg>
                  {/if}
                  <span class="icon-list-name">{M.ACCESS_LEVELS}</span>
                </li>
                <li class="icon-list-item" class:disabled={addon.value === -1}>
                  {#if addon.value === -1}
                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368">
                      <path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" />
                    </svg>
                  {:else}
                    <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 -960 960 960" width="48">
                      <path d="M378-222 130-470l68-68 180 180 383-383 68 68-451 451Z"></path>
                    </svg>
                  {/if}
                  <span class="icon-list-name">{M.PAYWALLS}</span>
                </li>
              </ul>
            </div>
            <div class="price-table-footer">
              <a class="price-table-button" on:click={() => select(addon)}>
                {#if addon.value < initialValue}
                  {M.CHANGE}
                {:else}
                  {M.PURCHASE_NOW}
                {/if}
                <svg xmlns="http://www.w3.org/2000/svg" class="price-table-arrow" height="48" viewBox="0 -960 960 960" width="48">
                  <path
                    d="m695.461-314.463-32.615-31.999 109.847-110.231H140.001v-45.383h633.692L663.462-611.923l31.614-31.999 164.923 164.537-164.538 164.922Z"></path>
                </svg>
              </a>
            </div>
          </div>
        </div>
      {/each}
    </div>
  {/if}
</div>
